import React, { useEffect, useState } from 'react'
import Loader from '../../Components/Loader';
import { Box, Button, Modal, Pagination, Stack, Typography } from '@mui/material';
import { Link } from 'react-router';
import TruncatedText from '../../Components/TruncatedText';
import { useQueryStore } from '../../store/useQueryStore';

const QueryDisplayTable = () => {
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);
    const [search, setSearch] = useState('');
    const [field, setField] = useState('name');
    const [loading, setLoading] = useState('');
    const [itemId, setItemId] = useState('');
    const [open, setOpen] = useState('');

    const { getQuery, query, deleteQuery } = useQueryStore()

    const getQuerydata = async () => {
        setLoading(true)
        let res = await getQuery(pageNumber, pageSize, search, field)
        if (res) {
            setTotalPages(res?.totalPages);
        }
        setLoading(false)
    }

    const handleDelete = (id) => {
        setItemId(id)
        setOpen(true)
    }

    const handleCancelDelete = () => {
        setOpen(false);
    };

    const handleChangePagination = (event, value) => {
        setPageNumber(value);
    };

    const handleConfirmDelete = async () => {
        try {
            setOpen(false)
            setLoading(true)
            const res = await deleteQuery(itemId)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        getQuerydata()
    }, [pageNumber, search, field])
    return (
        <div>
            <div className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden">
                <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50 flex justify-between items-center">
                    <h3>Email Requests</h3>

                </div>
                <Loader loading={loading}>
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="bg-neutral-50 text-left text-xs text-neutral-500 uppercase tracking-wider">
                                <th className="px-6 py-3">Company Name</th>
                                <th className="px-6 py-3">Contact Name</th>
                                <th className="px-6 py-3">Phone Number</th>
                                <th className="px-6 py-3">Email</th>
                                <th className="px-6 py-3 w-[30%]">Comment</th>
                                <th className="px-6 py-3">Link</th>
                                <th className="px-6 py-3 text-right">Action</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-neutral-200 text-neutral-700">
                            {(query || []).map((ele, i) => (
                                <tr key={i} className="hover:bg-neutral-50">
                                    <td className="px-6 py-4">
                                        <div className="flex items-center">
                                            <span>{ele?.companyName}</span>
                                        </div>
                                    </td>

                                    <td className="px-6 py-4">{ele?.contactName}</td>
                                    <td className="px-6 py-4">{ele?.phoneNumber}</td>
                                    <td className="px-6 py-4">{ele?.email}</td>

                                    <td className="px-6 py-4 text-sm text-neutral-600 w-[30%]">
                                        <TruncatedText text={ele?.comment} limit={50} />
                                    </td>

                                    <td className="px-6 py-4 text-sm text-blue-600 hover:underline">
                                        <Link to={ele?.planLink} target="_blank">
                                            {ele?.planLink}
                                        </Link>
                                    </td>

                                    <td className="px-6 py-4 text-right text-sm">
                                        <button
                                            className="text-neutral-500 hover:text-neutral-600"
                                            onClick={() => handleDelete(ele?._id)}
                                        >
                                            <i className="fas fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </Loader>

            </div>

            <div className="flex justify-end items-center mb-6">
                <div className="flex justify-between items-center mb-6">
                    <Stack spacing={2} className="flex items-end mt-4">
                        <Pagination
                            count={totalPages}
                            onChange={handleChangePagination}
                            variant="outlined"
                            shape="rounded"
                            sx={{
                                "& .MuiPaginationItem-root": {
                                    color: "white",
                                    borderColor: "#000",
                                    backgroundColor: "#000",
                                },
                                "& .Mui-selected": {
                                    backgroundColor: "#333 !important",
                                    color: "white",
                                },
                                "& .MuiPaginationItem-root:hover": {
                                    backgroundColor: "#444",
                                    color: "white",
                                },
                            }}
                        />
                    </Stack>
                </div>
            </div>

            <Modal
                open={open}
                onClose={handleCancelDelete}
                aria-labelledby="confirm-delete-modal"
                aria-describedby="modal-to-confirm-deletion"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '5px',
                        boxShadow: 24,
                        width: { xs: "80%", md: "500px" },
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        Are you sure you want to delete this Query?
                    </Typography>
                    <Button variant="outlined" color="#274156" onClick={handleConfirmDelete}>
                        Yes
                    </Button>
                    <Button variant="outlined" color="#274156" onClick={handleCancelDelete} sx={{ marginLeft: '10px' }}>
                        No
                    </Button>
                </Box>
            </Modal>
        </div>
    )
}

export default QueryDisplayTable
